import { UserType } from "@/constants";

export type ReceiptScope = "property" | "payment";

export interface ReceiptScopeAccess {
  /**
   * Whether the portal may ask which receipt to download. The server still has
   * the final say through `entire_payment_available` on `receipt-options`:
   * OMT/AMS users only choose when every property on the transaction is theirs.
   */
  canChooseScope: boolean;
  /** Scope used when the portal does not offer a choice. */
  defaultScope: ReceiptScope;
}

/**
 * Which payment receipt each portal may download.
 *
 * Operators pick between this property alone and the entire payment; OMT/AMS
 * users pick only when the whole transaction is theirs; registrants always get
 * the entire payment; government only ever gets the property they are viewing.
 */
export function receiptScopeAccess(
  userType: UserType | null | undefined,
): ReceiptScopeAccess {
  switch (userType) {
    case UserType.OPERATOR:
    case UserType.OMT_AMS:
      return { canChooseScope: true, defaultScope: "property" };
    case UserType.REGISTRANT:
      return { canChooseScope: false, defaultScope: "payment" };
    default:
      return { canChooseScope: false, defaultScope: "property" };
  }
}
